class Globals{


    static BASE_PATH='';
    static DATA_PATH='/data/';

    static SECTION_HOME='home';
    static SECTION_ABOUT='about';
    static SECTION_MODELS='models';
    static SECTION_SERVICE='service';
    static SECTION_DEALER='dealer';
    static SECTION_TESTDRIVE='testdrive';


    static HOME_SLIDER_STATUS_HOME='home';
    static HOME_SLIDER_STATUS_MODELS='models';
    static HOME_SLIDER_STATUS_HIDDEN='hidden';


    static setBasePath(bp){
        Globals.BASE_PATH=bp;
        Globals.DATA_PATH=Globals.BASE_PATH+Globals.DATA_PATH;
    }

    
    
}
//export default Globals;
export {Globals};